import React, { PropsWithChildren } from 'react';
import { Control } from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';
import { DialogFooter } from '@/components/ui/dialog';
import { FormField } from '@/components/ui/form';
import Dialog from '@/components/template/Dialog';
import InlineInput from '@/components/InlineInput';

import { EditMemberForm } from './schema';

interface IProps extends PropsWithChildren {
  control: Control<EditMemberForm>;
  onSubmit: (
    handleClose: () => void,
  ) => (event: React.SyntheticEvent) => Promise<void> | void;
  isLoading: boolean;
  onClose: () => void;
}

const EditMemberDialogView: React.FC<IProps> = ({
  control,
  isLoading,
  onSubmit,
  children,
  onClose,
}) => (
  <Dialog
    title="Editar membro"
    description="Atualize os dados administrativos do membro."
    trigger={children}
    tooltipContent="Editar membro"
    onClose={onClose}
  >
    {({ handleClose }) => (
      <form onSubmit={onSubmit(handleClose)}>
        <div className="grid gap-4 py-4">
          <FormField
            control={control}
            name="externalId"
            render={({ field }) => (
              <InlineInput
                title="ID Externo"
                disabled={isLoading}
                {...field}
                value={field.value ?? ''}
              />
            )}
          />

          <FormField
            control={control}
            name="fullName"
            render={({ field }) => (
              <InlineInput
                title="Nome completo"
                disabled={isLoading}
                {...field}
              />
            )}
          />

          <FormField
            control={control}
            name="email"
            render={({ field }) => (
              <InlineInput title="E-mail" disabled {...field} />
            )}
          />
        </div>

        <DialogFooter>
          <Button type="submit" disabled={isLoading}>
            {isLoading && (
              <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
            )}
            Salvar
          </Button>
        </DialogFooter>
      </form>
    )}
  </Dialog>
);

export default EditMemberDialogView;
